// Geometria schematica del serramento per l'anteprima SVG (nessun motore CAD: solo forma, misure,
// corda e battenti). Le misure sono in mm, con origine in alto a sinistra e asse y verso il basso.

// Riconosce la forma dal codice del tipo disegno (maiuscolo). I codici usati dal calcolo dell'area
// (CENTINATO, TRAPEZOIDALE2, CASETTA) coincidono con quelli del VB; gli altri sono tollerati per
// nome (es. "Oblò", "Rampante") perché il catalogo dei tipi è gestito dal SuperAdmin.
export function tipoForma(forma) {
    const f = String(forma || "").toUpperCase();
    if (f.includes("CENTIN")) return "centinato";
    if (f.includes("CASETTA")) return "casetta";
    if (f.includes("OBL")) return "oblo";
    if (f.includes("TRAP") || f.includes("RAMP")) return "trapezio";
    return "rettangolo";
}

const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : 0;
};

// Restituisce { tipo, w, ht, path, lati } con path = contorno esterno del telaio.
// Se mancano le misure necessarie alla forma si ricade sul rettangolo.
export function geometria({ forma, l, h, corda }) {
    const L = num(l);
    const H = num(h);
    const c = num(corda);
    let tipo = tipoForma(forma);
    if (!L || !H) return null;

    if (tipo === "centinato" && !c) tipo = "rettangolo";
    if (tipo === "casetta" && !c) tipo = "rettangolo";

    switch (tipo) {
        case "centinato": {
            // Spalle alte H e freccia dell'arco c (come l'area: rettangolo L×H + segmento circolare).
            const ht = H + c;
            const r = c / 2 + (L * L) / (8 * c);
            const arcoGrande = c > L / 2 ? 1 : 0;
            return {
                tipo, w: L, ht, corda: c,
                path: `M0 ${ht} L0 ${c} A ${r} ${r} 0 ${arcoGrande} 1 ${L} ${c} L${L} ${ht} Z`,
            };
        }
        case "casetta": {
            const ht = H + c;
            return { tipo, w: L, ht, corda: c, path: `M0 ${ht} L0 ${c} L${L / 2} 0 L${L} ${c} L${L} ${ht} Z` };
        }
        case "oblo": {
            // Oblò: cerchio con diametro pari alla larghezza.
            const r = L / 2;
            return {
                tipo, w: L, ht: L,
                path: `M0 ${r} A ${r} ${r} 0 1 1 ${L} ${r} A ${r} ${r} 0 1 1 0 ${r} Z`,
            };
        }
        case "trapezio": {
            // Lato sinistro alto H, lato destro alto h2: con la corda come altezza media (come l'area
            // di TRAPEZOIDALE2, corda × L) h2 = 2·corda − H; senza corda un lato è il 60% dell'altro.
            let h2 = c ? (forma && String(forma).toUpperCase().includes("TRAPEZOIDALE2") ? 2 * c - H : c) : H * 0.6;
            h2 = Math.min(Math.max(h2, H * 0.15), H * 2);
            const ht = Math.max(H, h2);
            return {
                tipo, w: L, ht,
                path: `M0 ${ht} L0 ${ht - H} L${L} ${ht - h2} L${L} ${ht} Z`,
            };
        }
        default:
            return { tipo: "rettangolo", w: L, ht: H, path: `M0 0 H${L} V${H} H0 Z` };
    }
}
